import axios from "@/utils/request";




export function getzaBranchfindByToken(req, res){
  return axios.post(`/api/zaBranch/web/findByToken`).then(res=>res.data)
}


//PDF-内容
export function getResourceCatalogPDF(params) {
  return axios.get(`/api/resourceCatalog/web/readPDF`, {
    params,
    responseType: 'blob',
    timeout: 1000*120,
  }).then(res => res.data)
}

//PDF-目录

export function getResourceCatalog(params) {
  return axios.get(`/api/resource/web/resCatalogs`, {
    params
  }).then(res => res.data)
}


//获取用户对该资源的权限
export function getProductGetAuth(data,params){
  return axios.post(`/api/product/web/getAuth`,data, { params }).then(res => res.data)
}


// WEBPACK FOOTER //
// ./src/api/read-instance.js